export interface IMeetingsGmeetsColours {
  _id?: string;
  AG_Name: string;
  AG_ItemNumber: string;
  AG_TextColour: string;
  AG_BackgroundColour: string;
  AG_Committee: EAG_Committee;
}

export enum EAG_Committee {
  firstCommittee = 'firstCommittee',
  secondCommittee = 'secondCommittee',
  sixthCommittee = 'sixthCommittee',
  fourthCommittee= 'fourthCommittee',
  ecosocmeetings = 'ecosocmeetings',
  commissionForSocialDevelopment = 'commissionForSocialDevelopment',
  unitedNationsForumOnForests = 'unitedNationsForumOnForests',
  commissionOnTheStatusOfWomen = 'commissionOnTheStatusOfWomen',
  commissionOnPopulationAndDevelopment = 'commissionOnPopulationAndDevelopment',
  ldc = 'ldc',
  thirdCommittee = 'thirdCommittee',
}
